import React, { useState, useEffect } from 'react';
import Navbar from '../components/Navbar';
import '../components/Navbar.css';

function DocumentsPage() {
  document.title = 'Florida Elections - Recent Documents';
  
  const [docs, setDocs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchDocs = async () => {
      setLoading(true);
      setError(null);
      try {
        const res = await fetch('/api/documents/recent?limit=100');
        if (!res.ok) throw new Error(`HTTP ${res.status}`);
        const data = await res.json();
        setDocs(data);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };
    fetchDocs();
  }, []);

  if (loading) return <div style={{ background: '#fff', minHeight: '100vh' }}><Navbar /><main style={{ maxWidth: '900px', margin: '8px auto', padding: '12px' }}>Loading documents...</main></div>;
  if (error) return <div style={{ background: '#fff', minHeight: '100vh' }}><Navbar /><main style={{ maxWidth: '900px', margin: '8px auto', padding: '12px' }}>Error: {error}</main></div>;

  return (
    <div style={{ background: '#fff', minHeight: '100vh' }}>
      <Navbar />
      <main style={{ maxWidth: '1100px', margin: '8px auto', padding: '12px' }}>
  <h2>Recent Documents</h2>
        <p>Showing the most recent {docs.length} documents.</p>
        <div style={{ overflowX: 'auto' }}>
          <table border="1" style={{ borderCollapse: 'collapse', width: '100%' }}>
            <thead>
              <tr style={{ background: '#f2f2f2' }}>
                <th style={{ padding: 8 }}>Name</th>
                <th style={{ padding: 8 }}>Account</th>
                <th style={{ padding: 8 }}>Date</th>
                <th style={{ padding: 8 }}>Description</th>
              </tr>
            </thead>
            <tbody>
              {docs.map((d, i) => (
                <tr key={d._id || i} style={{ backgroundColor: i % 2 === 0 ? '#fafafa' : 'white' }}>
                  <td style={{ padding: 8 }}>{d.NameFull || ''}</td>
                  <td style={{ padding: 8 }}>{d.Account}</td>
                  <td style={{ padding: 8 }}>{d.Date}</td>
                  <td style={{ padding: 8 }}>
                    {d.FilePath ? (() => {
                      // Normalize FilePath and ensure it is served under /docs/
                      const raw = (d.FilePath || '').replace(/^\/+/, '');
                      const href = raw ? (raw.startsWith('docs/') ? '/' + raw : '/docs/' + raw) : null;
                      return href ? <a href={href} target="_blank" rel="noreferrer">{d.DocDesc || 'Open'}</a> : (d.DocDesc || '');
                    })() : (d.DocDesc || '')}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </main>
    </div>
  );
}

export default DocumentsPage;
